import api from "./api"

export const getNegativeUsageAPI = async ({ sido, kapt_code, ended_at }) => {
  const { data } = await api.get("/api/analysis/negative", {
    params: { sido, kapt_code, ended_at }
  })
  return data
}

export const getLeakUnitsAPI = async ({ sido, kapt_code, dong }) => {
  const { data } = await api.get("/api/analysis/leak", {
    params: { sido, kapt_code, dong }
  })
  return data
}

export const getOveruseUnitsAPI = async ({ sido, kapt_code, dong }) => {
  const { data } = await api.get("/api/analysis/overuse", {
    params: { sido, kapt_code, dong }
  })
  return data
}
